import { FilterValueState } from "client/Hooks";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement, ReactNode, useState } from "react";
import { Form } from "../Form/Form";
import { FormItem } from "../FormItem/FormItem";
import { TextInput } from "../TextInput/TextInput";
import { Toolbar } from "../Toolbar/Toolbar";

export type SearchFilterableFormProps = {
	filterable: FilterValueState<string>;
	onClose(): void;
};

export const SearchFilterableForm = (props: SearchFilterableFormProps): ReactElement => {
	const {
		filterable,
		onClose
	} = props;

	const {
		value,
		setValue
	} = filterable;

	const [searchTerm, setSearchTerm] = useState<string>(value);

	const searchHandler = (): void => {
		setValue(searchTerm);
		onClose();
	};

	const clearHandler = (): void => {
		setSearchTerm("");
		setValue("");
	};

	return (
		<Form onSubmit={searchHandler}>
			<FormItem label={localize("_GridFilterMenuTitle")}>
				<TextInput
					value={searchTerm}
					onChange={setSearchTerm}
					trackingId="search-term"
				/>
			</FormItem>
			<div>
				<Toolbar
					horizontalAlignment="right"
				>
					<Toolbar.Button
						kind="primary"
						text={localize("_Filter")}
						onClick={searchHandler}
						trackingId="filter-button"
					/>
					<Toolbar.Button
						kind="secondary"
						text={localize("_Clear")}
						onClick={clearHandler}
						trackingId="clear-button"
					/>
				</Toolbar>
			</div>
		</Form>
	);
};

SearchFilterableForm.displayName = "TableView.DefaultColumnFilterableForm";

export type ColumnFilterableFormBuilder = {
	columnFilterableFormFactory: (
		onClose: () => void
	) => ReactNode;
	isActive: boolean;
};

export function isColumnFilterableFormBuilder(
	filterable: FilterValueState<string> | ColumnFilterableFormBuilder
): filterable is ColumnFilterableFormBuilder {
	return "columnFilterableFormFactory" in filterable;
}
